import React, { useState, useEffect } from "react";
import "./banners.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { encode } from "base-64";
import { DeleteBannerImageAction, RetrieveAllBannerImageAction, BannerImageIsActiveViewAction, BannerListPageAction, BannerFilterAction, UpdateBannerImageSequenceAction } from "../../actions/bannerAction";
import { notify } from '../../services/notification';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { HiMenu, HiX } from "react-icons/hi";
import ConfirmationPopup from "../../component/ConfirmationPopup"; 
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableRow from "./drag";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";



function Banners() {
  const filterData = useSelector((state) => state.bannerfilter);
  const {  isSidebarOpen, toggleSidebar } = useMobileView();

  const PageData = useSelector((state) => state.bannerpage)
  const [Bannerdata, setBannerdata] = useState([]);
  const [isLoading, setLoading] = useState(false)
  
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [activeButton, setActiveButton] = useState(filterData?.filter_key);
  const [startIndex, setStartIndex] = useState(PageData?.page);
  const [bannerId, setBannerId] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [sequenceUpdate, setSequenceUpdate] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onCreateClick = () => {
    navigate("/createbanners")
  }

  useEffect(() => {
    getBannerImageData();
  }, [page]);

  

  const onEditClick = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/editbanners/${encodeid}`);
  }

  
  

  async function getBannerImageData(filter) {
    setLoading(true);
    const newStartIndex = (page - 1) * 10 + 1;
    setStartIndex(newStartIndex);
    var response = await dispatch(RetrieveAllBannerImageAction(page, filter ? filter : activeButton));
    if (response?.status === 200 || response != null) {
      setCount(Math.ceil(response.data.count / 10));
      setBannerdata(response.data.results.data)
      setpaginationListcount(response.data.count);
      setLoading(false);
    } else if (response === undefined) {
      setLoading(false);
    }

  }

 

  const handleOnDeleteClick = async () => {
    setLoading(true);
    let response = await dispatch(DeleteBannerImageAction(bannerId));
    if (response?.status === 200) {
      notify.success(response.data.msg)
      getBannerImageData();
      setLoading(false);
      handleCloseDeleteConfirmationModal()
      window.scroll(0, 0);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  const handleOpenDeleteConfirmationModal = (id) => {
    setBannerId(id)
    setOpenDeleteModal(true)
  }

  const handleCloseDeleteConfirmationModal = () => {
    setBannerId("")
    setOpenDeleteModal(false)
  }

  const handleCheckboxChange = (id, checked) => {
    if (checked) {
      handleOnActiveClick(id, "true");
    } else {
      handleOnActiveClick(id, "false");
    }
  };

  const handleOnActiveClick = async (id, data) => {
    const apiReq = {
      is_active: data
    }
    setLoading(true);
    let response = await dispatch(BannerImageIsActiveViewAction(apiReq, id));
    if (response?.status === 200) {
      notify.success(response.data.msg)
      getBannerImageData();
      setLoading(false);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  const handleClick = (para) => {
    getBannerImageData(para)
    setActiveButton(para);
    dispatch(BannerFilterAction(para))
  };

  const handlePageChange = (event, value) => {
    dispatch(BannerListPageAction(value));
    setPage(value);
  };

  const updateSequenceOnServer = async () => {
    const sequenceRequestBody = {
      sequence: Bannerdata
        .filter(item => item.is_active === true)
        .map((item, index) => ({
          id: item.id,
          sequence: index + 1,
        })),
    };
    setLoading(true);
    let response = await dispatch(UpdateBannerImageSequenceAction(sequenceRequestBody));
    if (response?.status === 200) {
      notify.success(response.data.message)
      setSequenceUpdate(false);
      getBannerImageData();
      setLoading(false);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  const moveRow = (dragIndex, hoverIndex) => {
    const draggedRow = Bannerdata[dragIndex];
    const updatedData = [...Bannerdata];
    updatedData.splice(dragIndex, 1);
    updatedData.splice(hoverIndex, 0, draggedRow);
    setBannerdata(updatedData);
    setSequenceUpdate(true);
  };

  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = Bannerdata?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="banners-container">
      <div className="banners-right-sidebar">
        <Header title="Banners" />
        {isLoading ? (
          <Loader />
        ) : (
          <DndProvider backend={HTML5Backend}>
            <div className="banners-first-collumn">
              <div className="banners-search">
                <div className="banners-label">
                  <button
                    type="button"
                    className={activeButton === "True" ? "active banners-create-button" : "banners-create-button"}
                    onClick={() => handleClick("True")}
                  >
                    Active
                  </button>
                  <button
                    type="button"
                    className={activeButton === "False" ? "active banners-create-button" : "banners-create-button"}
                    onClick={() => handleClick("False")}
                  >
                    Inactive
                  </button>
                  <div className="create-button">
                    <button
                      type="button"
                      className="banners-create-button"
                      onClick={onCreateClick}
                    >
                      Create
                    </button>
                    {sequenceUpdate && (
                      <button
                        type="button"
                        className="banners-save-button"
                        onClick={updateSequenceOnServer}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="table-data">
                <div>
                  <table className="table">
                    <tr className="tablesth">
                      <th>S.NO.</th>
                      <th>Title</th>
                      <th>Link</th>
                      <th>Sequence </th>
                      <th>Created by </th>
                      <th className="th-action">Action </th>
                    </tr>
                    {Bannerdata.map((data, index) => (
                      <DraggableRow key={data.id} data={data} index={index} moveRow={moveRow} startIndex={startIndex} onEditClick={onEditClick} handleCheckboxChange={handleCheckboxChange} handleOpenDeleteConfirmationModal={handleOpenDeleteConfirmationModal} />
                    ))}
                  </table>
                </div>
              </div>
              <div className="Pagination_section">
                <Stack spacing={2} >
                  <Pagination
                    count={count}
                    className="pagination"
                    page={page}
                    size="medium"
                    defaultPage={1}
                    color="primary"
                    onChange={handlePageChange}
                  />
                </Stack>
                <div className="count">
                  <b>
                    <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
              </div>
            </div>
          </DndProvider>
        )}
      </div>
      <ConfirmationPopup
        openDeleteModal={openDeleteModal}
        handleOnDeleteClick={handleOnDeleteClick}
        handleCloseDeleteConfirmationModal={handleCloseDeleteConfirmationModal}
        messageHeading={"WARNING!"}
        messageBody={"Are you sure you want to delete this Banner?"}
        isLoading={isLoading}
      />
    </div>
  );
}
export default Banners;